class LqdGMapHandler extends elementorModules.frontend.handlers.Base {

  onInit(...args) {

    super.onInit(...args);

    this.initGMap();

  }

  getDefaultSettings() {
    return {
      selectors: {
        mapElement: '[data-plugin-map]',
      }
    }
  }

  getDefaultElements() {
    const selectors = this.getSettings('selectors');
    return {
      $mapElement: this.$element.find(selectors.mapElement),
    }
  }

  initGMap() {

    if ( 'underfined' == typeof google || google == null ) return;

    this.elements.$mapElement.liquidMap();

  }
  
}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdGMapHandler, { $element } );
};